import { render, staticRenderFns } from "./TeamAvailability.vue?vue&type=template&id=31c1848b&"
import script from "./TeamAvailability.vue?vue&type=script&setup=true&lang=js&"
export * from "./TeamAvailability.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports